import { useRef as useRef } from 'react';
import {
  css as css,
  cx as cx,
} from '@emotion/css';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { fitty56sdk9q03su9 as fitty } from './external/fitty/ReactFittyHelper.mjs';
import { useLayoutEffectOnce29bdczj7e3dte as useLayoutEffectOnce } from '../../../../../../kotlin-react/react/useLayoutEffect.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
  addChildNodeajp8y977cuss as addChildNode,
} from '../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { ReactHTML_instance1us7d77fndncb as ReactHTML_instance } from '../../../../../../kotlin-react-dom/react/dom/html/ReactHTML.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance183u30r0z0tam as Companion_getInstance } from './CouplingImages.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_CardHeader() {
  _init_properties_CardHeader_kt__lgr0gt();
  var tmp = KProperty0();
  return CardHeader$delegate.g1m(null, getPropertyCallableRef('CardHeader', 0, tmp, _get_CardHeader_$ref_gog3pf(), null));
}
var CardHeader$delegate;
function fitContent(_this__u8e3s4, size) {
  _init_properties_CardHeader_kt__lgr0gt();
  return fitty(_this__u8e3s4, size * 0.3, size * 0.1, true);
}
function CardHeader$delegate$lambda($this$nfc, props) {
  _init_properties_CardHeader_kt__lgr0gt();
  var size = props.size;
  var headerContainerRef = useRef(null);
  useLayoutEffectOnce(CardHeader$delegate$lambda$slambda_0(headerContainerRef, size));
  setDefaultKey($this$nfc, '@rdk/43_4');
  // Inline function 'react.dom.html.ReactHTML.div' call
  // Inline function 'react.IntrinsicType' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$div) => {
    // Inline function 'emotion.react.css' call
    // Inline function 'emotion.css.ClassName' call
    var tmp0 = [props.className].slice();
    // Inline function 'emotion.css.ClassName' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'kotlin.apply' call
    var this_0 = {};
    // Inline function 'web.cssom.px' call
    var this_1 = size * 0.02;
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_0 = toString(this_1) + 'px';
    // Inline function 'web.cssom.px' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'web.cssom.Margin' call
    var horizontal = toString(0) + 'px';
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this_0.margin = toString(tmp0_0) + ' ' + toString(horizontal);
    // Inline function 'web.cssom.px' call
    var this_2 = size * 0.33;
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this_0.height = toString(this_2) + 'px';
    // Inline function 'web.cssom.VerticalAlign.Companion.top' call
    this_0.verticalAlign = 'top';
    // Inline function 'web.cssom.Overflow.Companion.visible' call
    this_0.overflow = 'visible';
    // Inline function 'web.cssom.Display.Companion.flex' call
    this_0.display = 'flex';
    // Inline function 'web.cssom.AlignItems.Companion.center' call
    this_0.alignItems = 'center';
    // Inline function 'web.cssom.FlexDirection.Companion.column' call
    this_0.flexDirection = 'column';
    // Inline function 'web.cssom.Position.Companion.relative' call
    this_0.position = 'relative';
    // Inline function 'web.cssom.scale' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this_0.transform = 'scale(' + toString(1.1) + ')';
    // Inline function 'web.cssom.em' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this_0.perspective = toString(10) + 'em';
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$44 = [css(this_0)];
    var tmp$ret$42 = tmp0.concat(tmp$ret$44);
    $this$div.className = cx.apply(null, [].slice.call(tmp$ret$42.slice()));
    setDefaultKey($this$div, '@rdk/56_8');
    // Inline function 'react.dom.html.ReactHTML.div' call
    // Inline function 'react.IntrinsicType' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'react.ChildrenBuilder.invoke' call
    var block = ($this$div) => {
      // Inline function 'emotion.react.css' call
      // Inline function 'emotion.css.ClassName' call
      // Inline function 'js.objects.unsafeJso' call
      // Inline function 'js.objects.unsafeJso' call
      // Inline function 'kotlin.apply' call
      var this_0 = {};
      // Inline function 'web.cssom.Position.Companion.absolute' call
      this_0.position = 'absolute';
      // Inline function 'web.cssom.Overflow.Companion.hidden' call
      this_0.overflow = 'hidden';
      // Inline function 'web.cssom.px' call
      var this_1 = size / 10 | 0;
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.borderRadius = toString(this_1) + 'px';
      // Inline function 'web.cssom.px' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.top = toString(0) + 'px';
      // Inline function 'web.cssom.px' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.left = toString(0) + 'px';
      // Inline function 'web.cssom.px' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.right = toString(0) + 'px';
      // Inline function 'web.cssom.px' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.bottom = toString(0) + 'px';
      // Inline function 'web.cssom.deg' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'web.cssom.rotatex' call
      var a = toString(20) + 'deg';
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.transform = 'rotatex(' + toString(a) + ')';
      // Inline function 'web.cssom.rgb' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.backgroundColor = 'rgb(' + 255 + ' ' + 255 + ' ' + 255 + ' / ' + 0.4 + ')';
      // Inline function 'web.cssom.url' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.backgroundImage = 'url(' + Companion_getInstance().j3p_1.w3o_1 + ')';
      // Inline function 'web.cssom.BackgroundRepeat.Companion.repeatX' call
      this_0.backgroundRepeat = 'repeat-x';
      // Inline function 'web.cssom.LineStyle.Companion.hidden' call
      this_0.borderStyle = 'hidden';
      // Inline function 'web.cssom.Color' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.borderColor = '#00000054';
      // Inline function 'web.cssom.px' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.borderWidth = toString(1) + 'px';
      // Inline function 'web.cssom.FontWeight.Companion.bold' call
      this_0.fontWeight = 'bold';
      $this$div.className = css(this_0);
      return Unit_instance;
    };
    addChild($this$div, 'div', block);
    setDefaultKey($this$div, '@rdk/75_8');
    // Inline function 'react.dom.html.ReactHTML.div' call
    // Inline function 'react.IntrinsicType' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'react.ChildrenBuilder.invoke' call
    var block_0 = ($this$div) => {
      // Inline function 'emotion.react.css' call
      // Inline function 'emotion.css.ClassName' call
      // Inline function 'js.objects.unsafeJso' call
      // Inline function 'js.objects.unsafeJso' call
      // Inline function 'kotlin.apply' call
      var this_0 = {};
      // Inline function 'web.cssom.px' call
      var this_1 = size * 0.33;
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.height = toString(this_1) + 'px';
      // Inline function 'web.cssom.integer' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.zIndex = 100;
      $this$div.className = css(this_0);
      $this$div.ref = headerContainerRef;
      setDefaultKey($this$div, '@rdk/81_12');
      // Inline function 'react.dom.html.ReactHTML.div' call
      // Inline function 'react.IntrinsicType' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'react.ChildrenBuilder.invoke' call
      var block = ($this$div) => {
        // Inline function 'emotion.react.css' call
        // Inline function 'emotion.css.ClassName' call
        // Inline function 'js.objects.unsafeJso' call
        // Inline function 'js.objects.unsafeJso' call
        // Inline function 'kotlin.apply' call
        var this_0 = {};
        // Inline function 'web.cssom.Display.Companion.flex' call
        this_0.display = 'flex';
        // Inline function 'web.cssom.AlignItems.Companion.center' call
        this_0.alignItems = 'center';
        // Inline function 'web.cssom.px' call
        var this_1 = size * 0.33;
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        this_0.height = toString(this_1) + 'px';
        $this$div.className = css(this_0);
        // Inline function 'kotlin.text.ifBlank' call
        var this_2 = props.headerContent;
        var tmp;
        if (isBlank(this_2)) {
          tmp = 'Unknown';
        } else {
          tmp = this_2;
        }
        // Inline function 'react.ChildrenBuilder.unaryPlus' call
        // Inline function 'react.ReactNode' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$147 = tmp;
        addChildNode($this$div, tmp$ret$147);
        return Unit_instance;
      };
      addChild($this$div, 'div', block);
      return Unit_instance;
    };
    addChild($this$div, 'div', block_0);
    return Unit_instance;
  };
  addChild($this$nfc, 'div', block);
  return Unit_instance;
}
var CardHeader$delegate$lambda$slambdaClass;
function CardHeader$delegate$lambda$slambda() {
  if (CardHeader$delegate$lambda$slambdaClass === VOID) {
    class $ {
      constructor($headerContainerRef, $size) {
        this.k3p_1 = $headerContainerRef;
        this.l3p_1 = $size;
      }
      *r1f($this$useLayoutEffectOnce, $completion) {
        var tmp0_safe_receiver = this.k3p_1.current;
        if (tmp0_safe_receiver == null)
          null;
        else {
          fitContent(tmp0_safe_receiver, this.l3p_1);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CardHeader$delegate$lambda$slambdaClass = $;
  }
  return CardHeader$delegate$lambda$slambdaClass;
}
function CardHeader$delegate$lambda$slambda_0($headerContainerRef, $size) {
  var i = new (CardHeader$delegate$lambda$slambda())($headerContainerRef, $size);
  var l = ($this$useLayoutEffectOnce, $completion) => i.r1f($this$useLayoutEffectOnce, $completion);
  l.$arity = 1;
  return l;
}
function _get_CardHeader_$ref_gog3pf() {
  return () => get_CardHeader();
}
var properties_initialized_CardHeader_kt_2r1yvz;
function _init_properties_CardHeader_kt__lgr0gt() {
  if (!properties_initialized_CardHeader_kt_2r1yvz) {
    properties_initialized_CardHeader_kt_2r1yvz = true;
    CardHeader$delegate = nfc(CardHeader$delegate$lambda);
  }
}
//region block: exports
export {
  get_CardHeader as get_CardHeader3obpaw752sk5t,
};
//endregion

//# sourceMappingURL=CardHeader.mjs.map
